import { BannerSection, SectionSubtitle, TBannerSectionDirection } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { WELCOME_ANCHOR } from '../../base/constants';
import { AssetsBaseUrl } from '../../base/env';

export interface IProps {
  bannerDirection?: TBannerSectionDirection;
  onGetStarted: (event: React.MouseEvent) => void;
}

const CommunitySection: React.FC<IProps> = ({ onGetStarted, bannerDirection }) => {
  const { t } = useTranslation();
  const title = t('prereg:Welcome.CommunitySection.Title');
  const descriptionHtml = t('prereg:Welcome.CommunitySection.DescriptionHtml');
  const imgSrc = `${AssetsBaseUrl}/feature/community_1.png`;
  return (
    <BannerSection direction={bannerDirection ?? 'right'} title={title} imgSrc={imgSrc}>
      <SectionSubtitle wrapperTag="div">{renderStringToReact(descriptionHtml, ETagType.div)}</SectionSubtitle>
      <a href={`#${WELCOME_ANCHOR}`} onClick={onGetStarted}>
        {t('prereg:Welcome.CommunitySection.Action')}
      </a>
    </BannerSection>
  );
};

export default CommunitySection;
